import { render, staticRenderFns } from "./AzioniLavorazioni.vue?vue&type=template&id=829ccc38&scoped=true"
import script from "./AzioniLavorazioni.vue?vue&type=script&lang=ts"
export * from "./AzioniLavorazioni.vue?vue&type=script&lang=ts"
import style0 from "./AzioniLavorazioni.vue?vue&type=style&index=0&id=829ccc38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829ccc38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('829ccc38')) {
      api.createRecord('829ccc38', component.options)
    } else {
      api.reload('829ccc38', component.options)
    }
    module.hot.accept("./AzioniLavorazioni.vue?vue&type=template&id=829ccc38&scoped=true", function () {
      api.rerender('829ccc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AzioniLavorazioni.vue"
export default component.exports